module.exports = __webpack_public_path__ + "img/logo_pak.c0738f99.jpg";